import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Input } from '@codex/basics';
import { Icon } from '@codex/icons';
import styled from 'styled-components';
import {
  setEmailMeBackProductID,
  setEmailMeBackXhrResponse,
  postEmailMeBackForm
} from '../../reduck/listingPageCommonData.reduck';
import {
  getEmailWhenBackFormTranslation,
  getPersonTitleTranslation
} from '../../translations/translations';
import Select from '../Select/Select';

const validateEmail = (email) =>
  /^[a-z0-9._+-]+@[a-z0-9._-]+\.[a-z]{2,4}$/i.test(String(email).toLowerCase());

const WrapperEmailWhenBackAjax = styled.div`
  background: #efefef;
  padding: 20px;
  margin: 10px 0;
  border-radius: 4px;
  min-width: calc(100% - 40px);
  width: 100%;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    min-width: 100%;
  }

  .dc-icon-cross {
    fill: #161b7a;
    font-size: 18px;
    margin: -4px 0 0 2px;
  }

  .dc-input-wrapper {
    input {
      background: #fff !important;
      box-shadow: inset 1px 1px 1px rgba(0, 0, 0, 0.1);
      border-color: #bbb;
      float: left;
      max-width: 200px;
      padding-left: 15px;
      padding-right: 15px;

      @media ${(p) => p.theme.breakpoints.mobile} {
        margin-right: 0;
        max-width: 200px;
        width: 100%;
      }
    }
  }

  .dc-form-item-label {
    border-radius: 3px 3px 0 0;
    color: #444;
    left: 12px;
    top: 15px;
    z-index: 1;

    &.dc-form-item-label-top {
      padding: 3px 5px;
    }
  }
`;

const InputField = styled.div`
  display: inline-block;
  margin-right: 8px;
  max-width: 200px;
  span {
    input {
      width: 200px;
      padding: 13px 12px;

      @media ${({ theme }) => theme.breakpoints.mobile} {
        width: 200px;
      }
    }
  }
`;

const CloseFormButton = styled.div`
  color: #161b7a;
  cursor: pointer;
  float: right;
  display: block;
  margin-bottom: 10px;

  &:hover {
    text-decoration: underline;
  }
`;

const WrapperInlinePs = styled.div`
  width: 100%;
  display: inline-block;
  
  ${InputField} {
    min-width: 90px;
    float: left;
    margin-bottom: 30px;

    .dc-select-icon {
      top: 13px;
    }
  }

  &:hover {
    text-decoration: underline;
  }
`;

const WrapperEmailWhenBackTitle = styled.div`
  color: inherit;
  display: inline-block;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: normal;
  margin-bottom: 10px;
  margin-top: 25px;
  text-transform: none;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-bottom: 12px;
  }
`;

const WrapperEmailWhenBackLegend = styled.p`
  color: inherit;
  display: inline-block;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: normal;
  margin-bottom: 10px;
  margin-top: 25px;
  text-transform: none;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-bottom: 12px;
  }
`;

const WrapperMandatoryText = styled.span`
  background: none;
  display: inline-block;
  margin-left: 8px;
  vertical-align: top;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-bottom: 30px;
  }
`;

const WrapperSgGutterBottom = styled.div`
  max-width: 200px;
`;

class EmailBack extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedTitleId: null,
      name: '',
      surname: '',
      email: ''
    };
  }

  componentWillUnmount() {
    this.props.onComponentUnmount();
  }

  renderXhrResponse() {
    return (
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: this.props.emailWhenBackXhrResponseContent }}
      />
    );
  }

  renderForm() {
    return (
      <div>
        <WrapperEmailWhenBackTitle className={'email-when-back-title'}>
          {getEmailWhenBackFormTranslation('title')}
        </WrapperEmailWhenBackTitle>
        <WrapperEmailWhenBackLegend className={'email-when-back-legend'}>
          {getEmailWhenBackFormTranslation('legend')}
        </WrapperEmailWhenBackLegend>
        <WrapperInlinePs className={'inline-ps'}>
          <InputField className={'inputField'}>
            <Select
              label={getEmailWhenBackFormTranslation('selectLabel')}
              name={'title_id'}
              options={getPersonTitleTranslation('selectTitles')}
              onSelectedItemChange={(selectedTitleObject) => {
                this.setState({ selectedTitleId: selectedTitleObject.id });
              }}
            />
          </InputField>
          <InputField className={'inputField'}>
            <Input
              type={'text'}
              name={'first_name'}
              value={this.state.name}
              placeholderText={getEmailWhenBackFormTranslation('name')}
              onChange={(e) => {
                this.setState({ name: e.target.value });
              }}
              interactivePlaceholder
            />
          </InputField>
          <InputField className={'inputField'}>
            <Input
              type={'text'}
              name={'last_name'}
              value={this.state.surname}
              placeholderText={getEmailWhenBackFormTranslation('surname')}
              onChange={(e) => {
                this.setState({ surname: e.target.value });
              }}
              interactivePlaceholder
            />
          </InputField>
        </WrapperInlinePs>

        <InputField className={'inputField email-field'} style={{ marginBottom: '20px' }}>
          <Input
            type={'email'}
            name={'email'}
            value={this.state.email}
            placeholderText={getEmailWhenBackFormTranslation('email')}
            onChange={(e) => {
              this.setState({ email: e.target.value });
            }}
            interactivePlaceholder
            valid={this.state.email === '' || validateEmail(this.state.email)}
          />
        </InputField>
        <WrapperMandatoryText className={'mandatory-text'}>
          {getEmailWhenBackFormTranslation('mandatoryText')}
        </WrapperMandatoryText>

        <WrapperSgGutterBottom className={'dc-site-currys sg-gutter-bottom'}>
          {validateEmail(this.state.email) ? (
            <Button
              full
              onClick={(e) => {
                e.preventDefault();
                this.props.onSubmitButtonClick({
                  productID: this.props.emailWhenBackFormProductID,
                  name: this.state.name,
                  surname: this.state.surname,
                  email: this.state.email,
                  titleId: this.state.selectedTitleId ? this.state.selectedTitleId : '0'
                });
              }}
            >
              Submit
            </Button>
          ) : (
            <Button full disabled>
              Submit
            </Button>
          )}
        </WrapperSgGutterBottom>
      </div>
    );
  }

  render() {
    return (
      <WrapperEmailWhenBackAjax id={'email-when-back-form'} className={'email-when-back-ajax'}>
        <CloseFormButton
          className={'closeFormButton'}
          onClick={() => {
            this.props.onCloseButtonClick();
          }}
        >
          Close
          <Icon icon={'Cross'} />
        </CloseFormButton>
        {this.props.emailWhenBackXhrResponseContent ? this.renderXhrResponse() : this.renderForm()}
      </WrapperEmailWhenBackAjax>
    );
  }
}

EmailBack.displayName = 'EmailBack';

EmailBack.propTypes = {
  emailWhenBackFormProductID: PropTypes.string.isRequired,
  onSubmitButtonClick: PropTypes.func,
  onCloseButtonClick: PropTypes.func,
  onComponentUnmount: PropTypes.func,
  emailWhenBackXhrResponseContent: PropTypes.string
};

EmailBack.defaultProps = {
  emailWhenBackXhrResponseContent: null,
  onCloseButtonClick: () => {},
  onSubmitButtonClick: () => {},
  onComponentUnmount: () => {}
};

function mapStateToProps(state) {
  return {
    emailWhenBackFormProductID: state.listingPage.commonData.emailWhenBackFormProductID,
    emailWhenBackXhrResponseContent: state.listingPage.commonData.emailWhenBackXhrResponseContent
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onCloseButtonClick: () => {
      dispatch(setEmailMeBackProductID(null));
    },
    onSubmitButtonClick: (params) => {
      dispatch(postEmailMeBackForm(params));
    },
    onComponentUnmount: () => {
      dispatch(setEmailMeBackXhrResponse(null));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailBack);
